import { makeAutoObservable } from 'mobx';

export interface IScrollStore {
  scrolling: boolean;
}
export default class ScrollStore implements IScrollStore {
  _scrolling = false;

  constructor() {
    makeAutoObservable(this);
  }

  get scrolling() {
    return this._scrolling;
  }

  set scrolling(isScrolling: boolean) {
    this._scrolling = isScrolling;
  }
}
